/**
 * HUB-B.2 — Bandeau SumUp pending (Historique + Centre Activité).
 */
import React from 'react';
import {
  formatPaymentDate,
  getSumupOrderLabel,
  getSumupPendingDetailLine,
} from '../../utils/paiements/paiementsDisplay';

export default function HistoriqueSumUpPendingPanel({
  payments,
  onConfirm,
  onCancel,
  confirming,
  cancelling,
  testIdPrefix = 'historique',
}) {
  if (!payments?.length) return null;

  return (
    <div
      className="rounded-xl border p-4"
      style={{ borderColor: 'rgba(22, 163, 74, 0.35)', background: 'var(--rm-success-muted)' }}
      data-testid={`${testIdPrefix}-sumup-pending-panel`}
    >
      <div className="mb-3">
        <h3 className="font-semibold text-[var(--rm-white)]">Paiements SumUp en attente</h3>
        <p className="text-xs text-[var(--rm-gray-400)]">
          Confirmez si le paiement a bien été encaissé, ou refusez s&apos;il a été annulé au TPE.
        </p>
      </div>
      <div className="space-y-2">
        {payments.map((payment) => {
          const checkoutId = payment.checkout_id;
          const dateLabel = formatPaymentDate(payment.updated_at || payment.created_at);
          const detailLine = getSumupPendingDetailLine(payment);
          const isConfirming = confirming === checkoutId;
          const isCancelling = cancelling === checkoutId;

          return (
            <div
              key={checkoutId}
              className="flex flex-wrap items-center justify-between gap-3 rounded-xl px-3 py-2"
              style={{ background: 'var(--rm-bg-panel)' }}
            >
              <div className="min-w-0 flex-1 text-sm text-[var(--rm-gray-100)]">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                  <span className="font-semibold">{getSumupOrderLabel(payment)}</span>
                  <span className="text-[var(--rm-gray-500)]">·</span>
                  <span className="text-[var(--rm-gray-300)]">{dateLabel}</span>
                </div>
                {detailLine && (
                  <div className="text-xs text-[var(--rm-gray-400)] mt-0.5 truncate">{detailLine}</div>
                )}
              </div>
              <div className="text-sm font-bold text-[var(--rm-success)] shrink-0">
                {Number(payment.amount || 0).toFixed(2)} €
              </div>
              <div className="flex flex-wrap items-center gap-2 shrink-0">
                {onCancel && (
                  <button
                    type="button"
                    onClick={() => onCancel(checkoutId)}
                    disabled={isConfirming || isCancelling}
                    className="btn-secondary px-3 py-2 min-h-[44px] text-xs"
                    data-testid={`${testIdPrefix}-sumup-cancel-${checkoutId}`}
                  >
                    {isCancelling ? '…' : 'Refuser'}
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => onConfirm(checkoutId)}
                  disabled={isConfirming || isCancelling}
                  className="btn-success px-3 py-2 min-h-[44px] text-xs"
                  data-testid={`${testIdPrefix}-sumup-confirm-${checkoutId}`}
                >
                  {isConfirming ? '…' : 'Confirmer'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
